import React from 'react';

import MuiAvatar from '@mui/material/Avatar';

function AvatarSizeObject(size) {
  this.width = size;
  this.height = size;
}

interface AvatarProps {
  src: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

export default function Avatar({ src, size = 'md' }: AvatarProps) {
  const sx = React.useMemo(() => {
    const avatarSize = new AvatarSizeObject(size);
    return { ...avatarSize };
  }, [size]);

  return <MuiAvatar src={src} sx={sx} />;
}
